import imageToBase64 from 'image-to-base64/browser';
 
export function getBase64(path) {
    //var path_blob=new Blob(path);
    const base = imageToBase64(path)
    return base;
	/*
    const reader = new FileReader();
    if(path){
    reader.readAsDataURL(path); }
    return new Promise((resolve, reject) => {
    const reader = new FileReader();
    console.log(path);
    reader.onload = () => resolve(reader.result?.toString() || '');
    reader.onerror = error => reject(error);
    if(path){
    reader.readAsDataURL(path); }
  });*/

}
